// router/guards/oauthGuard.js
import store from '../../store'
import TokenService from '@/services/token.service'
import { getCachedSettings } from '../../utils/helpers'

export default async (to, from, next) => {
	try {
		if (!store.getters['auth/isAuthenticated']) {
			const { token = '' } = to.query || {}
			if (token) {
				TokenService.saveAccessToken(token)
				await store.dispatch('auth/getProfile')
				getCachedSettings(store)
			}
		}
	} catch (e) {
	} finally {
		return next()
	}
}
